import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectOverview from '../../components/ProjectManagement/ProjectOverview';
import { useProjects } from '../../hooks/useProjects';
import { Box, Spinner, Text } from '@chakra-ui/react';

const ProjectDetailsPage: React.FC = () => {
    // Get project id from route params (URL: /dashboard/project/:id/details)
    const { id } = useParams<{ id: string }>();
    // Fetch all projects (or you can optimize to fetch one by id if you have such a hook)
    const { data: projects, isLoading, isError, error } = useProjects(true, false); // showAll=true, showArchived=false

    // Find the project by id
    const project = projects?.find((p: any) => p._id === id);

    if (isLoading) {
        return (
            <Box p={8} textAlign="center">
                <Spinner size="xl" />
                <Text mt={4}>Loading project details...</Text>
            </Box>
        );
    }

    if (isError) {
        return (
            <Box p={8} textAlign="center">
                <Text color="red.500">Failed to load project data.</Text>
            </Box>
        );
    }

    if (!project) {
        return (
            <Box p={8} textAlign="center">
                <Text color="red.500">
                    Project not found for id: {id}
                </Text>
            </Box>
        );
    }

    return <ProjectOverview project={project} />;
};

export default ProjectDetailsPage;